import {objectType} from "_src/constants";
import Selector from "_src/client/manipulators/selector";

export default class TextureHealer extends Selector {

  constructor(camera) {
    super(camera);
  }

  //Reimplemented
  _checkCanSelect(object) {
    return object.type === objectType.FUSION &&
      object.frames.length === 1 &&
      object.frames[0].textureList.length === 1 &&
      super._checkCanSelect(object);
  }

}

